namespace RS
{
    /** Logs to console when this method is invoked. */
    export function DebugLog(context: string, messageIn?: string, messageOut?: string): MethodDecorator
    {
        const logger = Logging.ILogger.get().getContext(context);
        return function(target: object, propertyKey: string, propertyDescriptor: PropertyDescriptor): void
        {
            if (!propertyDescriptor)
            {
                Log.warn("DebugLog decorator applied to an invalid method");
                return;
            }
            const oldFunc = propertyDescriptor.value;
            propertyDescriptor.value = function (this: object, ...args: any[])
            {
                const prefixMessage = messageIn 
                    ? `${messageIn || propertyKey}`
                    : `${propertyKey}(${args.map((a) => `${a}`).join(", ")})`;

                logger.log(prefixMessage, Logging.LogLevel.Debug);
                const retVal = oldFunc.apply(this, args);
                if (messageOut) { logger.log(`${messageOut}`, Logging.LogLevel.Debug); }
                return retVal;
            };
            Object.defineProperty(target, propertyKey, propertyDescriptor);
        };
    }
}